







































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Button, Card, Form, FormItem, Input, Option, Select } from 'element-ui';
import { PartnerFields, PartnerScopedInput } from '@/types/graphql/schemaTypes';
import { partnerService } from '@/services/PartnerService.ts';
import get from 'lodash/get';

// mixins
import countries from '@/mixins/countryOptions';

// rules
import rules from '@/rules/rules';

// gql
import fetchPartnersQuery from '@/graphql/queries/partners/FetchPartners.gql';

@Component({
  apollo: {
    partner: {
      query: fetchPartnersQuery,
      variables() {
        return {
          partnerId: this.$route.params.id
        };
      },
      update(data) {
        if (!this.isCreate && data.partners) {
          this.partnerInput = this.formatPartnerInput(data?.partners?.[0]);
        }

        return data && data.partners[0];
      },
      fetchPolicy: 'cache-and-network'
    }
  },
  components: {
    'el-button': Button,
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class Details extends Mixins(countries) {
  @Prop({ required: false }) private isCreate!: boolean;

  private isCancelable = false;
  private isEditing = false;
  private isLoading = false;
  private partner: PartnerFields | null = null;
  private partnerInput: PartnerScopedInput = this.formatPartnerInput();
  private readonly rules = rules;

  $refs!: {
    partnerForm: HTMLFormElement;
  };

  private formatPartnerInput(partner?: PartnerFields | null): PartnerScopedInput {
    return {
      address: {
        city: get(partner, 'address.city'),
        countryCode: get(partner, 'address.country.unLocode'),
        line1: get(partner, 'address.line1'),
        line2: get(partner, 'address.line2'),
        prefecture: get(partner, 'address.prefecture'),
        postalCode: get(partner, 'address.postalCode')
      },
      faxNumber: get(partner, 'faxNumber'),
      normalizedName: get(partner, 'normalizedName'),
      note: get(partner, 'note'),
      name: get(partner, 'name'),
      phoneNumber: get(partner, 'phoneNumber'),
      url: get(partner, 'url')
    };
  }

  mounted() {
    if (this.isCreate) {
      this.partnerInput = this.formatPartnerInput();
      this.isEditing = true;
    }
    setTimeout(() => (this.isCancelable = true), 500);
  }

  private cancel() {
    if (this.isCancelable) {
      if (this.isCreate) {
        this.$router.go(-1);
      } else {
        this.resetPartnerInput();
      }
    }
  }

  private resetPartnerInput() {
    this.partnerInput = this.formatPartnerInput(this.partner);
    this.isEditing = false;
    this.$refs.partnerForm.clearValidate();
  }

  private async submit() {
    this.$refs.partnerForm.validate(async(valid: boolean) => {
      if (!valid || !this.partnerInput) {
        return;
      }
      try {
        this.isLoading = true;

        const response = await partnerService
          .upsertPartner(this.partnerInput, this.$route.params.id);

        if (response) {
          this.$emit('refresh', response.data?.upsertPartner);
          this.isEditing = false;
          if (this.isCreate && response.data?.upsertPartner && response.data?.upsertPartner?.id) {
            const id = response.data?.upsertPartner?.id;
            this.$router.push({ name: 'partnerDetails', params: { id: response.data?.upsertPartner?.id } });
          }
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.isCreate ? this.$t('success.created') : this.$t('success.updated'),
            time: 2000
          });
        }
      } catch (error) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      } finally {
        this.isLoading = false;
      }
    });
  }
}
